import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Star } from 'react-feather';
import Icon, { IconColors, IconSizes } from '../../icon';
import Tooltip from '../../tooltip';
import useTranslation from '../../../../utils/translation-utils';

const RenFavourite = ({
  id, data, accessor, onAction,
}) => {
  const favourite = data[accessor];
  const [getTranslation] = useTranslation();

  return (
    <Tooltip description={favourite ? getTranslation('CLICK_UNSTAR') : getTranslation('CLICK_STAR')}>
      <div className="tbl-ren-fav" onClick={() => onAction(id)}>
        <Icon
          icon={Star}
          className={clsx({ 'trf-icon-selected': favourite })}
          color={favourite ? IconColors.PRIMARY : IconColors.LIGHT_GREY}
          size={IconSizes.MEDIUM}
        />
      </div>
    </Tooltip>
  );
};

RenFavourite.defaultProps = {
  data: {},
  onAction: () => {},
};

RenFavourite.propTypes = {
  id: PropTypes.string.isRequired,
  accessor: PropTypes.string.isRequired,
  data: PropTypes.shape(),
  onAction: PropTypes.func,
};

export default RenFavourite;
